import {useCallback, useRef, useState} from 'react';
import {copyToClipboard} from '@Utils/clipboard.util';
import {noop} from '@Utils/general.util';

const FEEDBACK_TIMEOUT = 1500;

export interface CopyToClipboardWithFeedbackData {
  onCopy: VoidFunction;
  doShowFeedback: boolean;
}

export const useCopyToClipboardWithFeedback = (textToCopy: string, onFeedbackShowComplete = noop, feedbackTimeout = FEEDBACK_TIMEOUT): CopyToClipboardWithFeedbackData => {
  const [doShowFeedback, setDoShowFeedback] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const onCopySuccess = (): void => {
    clearTimeout(timeoutRef.current);
    setDoShowFeedback(true);
    timeoutRef.current = setTimeout(() => {
      setDoShowFeedback(false);
      onFeedbackShowComplete();
    }, feedbackTimeout);
  };

  const onCopy = useCallback((): void => {
    copyToClipboard(textToCopy).then(onCopySuccess).catch(noop);
  }, [textToCopy]);

  return {onCopy, doShowFeedback};
};
